import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, CalendarCheck } from 'lucide-react';
import { COMPANY } from '../data/mock';

const CallBar = () => {
  return (
    <div className="lg:hidden fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-[#e3ecda] shadow-[0_-6px_24px_-12px_rgba(20,50,25,0.3)]">
      <div className="grid grid-cols-2 gap-2 p-2.5">
        <a
          href={COMPANY.phoneHref}
          className="flex items-center justify-center gap-2 h-12 rounded-full bg-brand text-white font-semibold text-[15px]"
        >
          <Phone className="h-4 w-4" /> Call Now
        </a>
        <Link
          to="/contact"
          className="flex items-center justify-center gap-2 h-12 rounded-full border border-[#cbdcbb] text-[#13251b] font-semibold text-[15px]"
        >
          <CalendarCheck className="h-4 w-4 text-brand" /> Book
        </Link>
      </div>
    </div>
  );
};

export default CallBar;
